import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Table, Empty, Divider, Select } from 'antd';

import { Action, updateInArray } from 'fennec-ui'
import Filtered from '../Filtered'
import { DropdownAction } from 'fennec-ui'
import { GET, POST, queryFilterByItem, errorCatch } from 'fennec-ui'
import "./index.css"
import { createUseStyles } from 'react-jss';

import NoviePromokodi from '../../forms/NoviePromokodi'
import IzmenitPromokodi from '../../forms/IzmenitPromokodi';

const { Option } = Select;

const useStyles = createUseStyles({
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-3px",
            left: "10px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "30px"
        }
    },
    cardSmall: {
        '& .ant-card-body': {
            padding: "0px"
        }
    }
})

function Btn(props) {
    const dispatch = useDispatch();
    const { object, sourceKey, auth, context, queryFilterContext, soruceID, setPromokodi } = props;
    return (
        <>
            <DropdownAction items={[
                {
                    ...props,
                    title: "Изменить",
                    auth: auth,
                    modal: {
                        width: "800px",
                        title: "Изменить промокод",
                    },
                    object: object,
                    mode: "MenuItem",
                    action: (values, unlock, close) => {
                        POST(auth, '/api/promokodi/update', {
                            ...values, ID: (object) ? object.ID : undefined,
                            promouter: { userID: values?.promouter?.ID },
                        },
                            ({ data }) => {
                                setPromokodi(o => updateInArray(o, data))
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    context: context,
                    sourceKey: sourceKey,
                    soruceID: object?.meropriyatieID,
                    form: IzmenitPromokodi,
                    queryFilterContext: queryFilterContext,
                }
            ]} />
        </>
    )
};

export default function PromokodiBlock(props) {
    const { auth, source, create, ctx, sourceKey, title, size, event } = props;
    const [loading, setLoading] = useState(false);
    const [promokodi, setPromokodi] = useState([])
    const concatSybmol = (source) => {
        return (source.indexOf("?") >= 0) ? "&" : "?";
    };
    useEffect(() => {
        let src = "";
        if (ctx) {
            let q = queryFilterByItem(ctx);
            if (q) {
                src = source + ((ctx || q) ? concatSybmol(source) + q : "");
            }
        } else {
            src = source
        }
        if (src) {
            setLoading(true);
            GET(auth, src,
                ({ data }) => {
                    setPromokodi(data)
                    setLoading(false);
                },
                (err) => errorCatch(err, setLoading(false)));
        }
    }, [ctx]);

    const filters = [
        {
            name: 'Активная',
            value: item => !item.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "active",
            type: "bool",
            filter: true
        },
        {
            name: 'Неактивная',
            value: item => item.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "notActive",
            type: "bool",
            sort: true,
            filter: true
        },
        {
            name: 'Промокод',
            value: item => item.promokod,
            field: "promokod",
            type: "string",
            sort: true,
            filter: true
        },
        {
            name: 'Описание',
            value: item => item.opisanie,
            field: "opisanie",
            type: "string",
            sort: true,
            filter: true
        }
    ];
    const columns = () => {
        var c = [];
        c.push({
            title: 'Промокод',
            render: (text, record) => {
                return (<div>
                    <div>
                        {record.promokod}
                    </div>
                    {(record?.promouter?.user) && <div style={{fontSize: "12px", color: "rgba(0,0,0,0.65)"}}>
                        {record?.promouter?.user?.lastname} {record?.promouter?.user?.firstname}
                    </div>}
                </div>);
            }
        });
        c.push({
            title: 'Описание',
            render: (text, record) => {
                return (record.opisanie);
            }
        });
        c.push({
            title: 'Активный',
            render: (text, record) => {
                return (!record.notActive) ? "Да" : "Нет";
            }
        });

        if (event?.ID) {
            c.push({
                title: 'Шаблонный',
                render: (text, record) => {
                    return (record.shablonniiPromokod) ? "Да" : "";
                }
            });
        }

        let organizatorKey = {}
        if (event?.organizatorFederatsiyaID) {
            organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
        } else if (event?.organizatorRegionalnoeOtdelenieID) {
            organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
        } else if (event?.organizatorShkolaID) {
            organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
        } else if (event?.organizatorMeropriyatiyaID) {
            organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
        }

        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<Btn auth={auth} soruceID={event?.ID} index={index + 1} setPromokodi={setPromokodi} object={record} create={create} sourceKey={sourceKey} queryFilterContext={(ctx) ? ctx : organizatorKey} />),
        });
        return c;
    };
    const createAction = (values, unlock, close) => {
        POST(auth, "/api/promokodi/new", {
            ...values,
            ...((ctx) ? ctx : {}),
            // ...((context && context.object) ? context.object(ctx) : {}),
            ...((event?.ID) ? { meropriyatieID: event.ID } : {}),
            promouter: { userID: values?.promouter?.ID },
        }, //values,
            ({ data }) => {
                if (data) {
                    setPromokodi(o => updateInArray(o, data))
                }
                close();
            },
            (err) => errorCatch(err, unlock));
    };

    const NewElement = () => {
        let organizatorKey = {}
        if (event?.organizatorFederatsiyaID) {
            organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
        } else if (event?.organizatorRegionalnoeOtdelenieID) {
            organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
        } else if (event?.organizatorShkolaID) {
            organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
        } else if (event?.organizatorMeropriyatiyaID) {
            organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
        }

        return (
            <Action {...props}
                mode={"button"}
                // disabled={(context && context.collection && !ctx)}
                auth={auth}
                action={createAction}
                form={NoviePromokodi}
                triggerOptions={{
                    type: "primary"
                }}
                title={"Новый промокод"}
                modal={{
                    width: "35%",
                    minWidth: "350px",
                    title: "Новый промокод",
                }}
            // context={context}
            // sourceKey={sourceKey}
            // queryFilterContext={(context && context.mix) ? context.mix(ctx || {}) : organizatorKey}
            />
        )
    };
    return (
        <>
            <Filtered filters={filters} data={promokodi /*(!context) ? promokodi: promokodi.filter(filterByContext)*/}
                addition={(create && size === "small") ?
                    NewElement() : <></>
                }
                content={items => (
                    <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                        <div style={{ padding: "10px" }}>
                            {title || <Divider type="horizontal" orientation="left">
                                Промокоды
                            </Divider>}
                            {create && <>
                                {size !== "small" && <div style={{ paddingBottom: "10px", display: "flex", justifyContent: "flex-end" }}>
                                    {NewElement()}
                                </div>}
                            </>}
                            <Table loading={loading} pagination={false} columns={columns()} dataSource={items} locale={{ emptyText: <Empty description={"Нет промокодов"}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </div>
                    </div>
                )} />
        </>
    );
}
